module.exports = __webpack_public_path__ + "static/media/icon-add.d8a8f551.svg";